<template>
    <section :class="cssClass">
        <div class="divider__text" v-if="hasText">
            <slot></slot>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        cssClass: {
            type: String,
            default: 'divider',
        },
    },
    computed: {
        hasText() {
            return !!this.$slots.default;
        },
    },
})
export default class Divider extends Vue {
    name = 'divider';
}

Vue.component('divider', Divider);
</script>
